// Build-time application configuration.
//
// All values come from Vite `import.meta.env` (VITE_* variables) so nothing
// sensitive or environment-specific is hard-coded. The Cognito User Pool id,
// app client id, AWS region, and AppSync GraphQL URL are supplied by the
// deployment pipeline. See .env.example for the full list.

export interface AppConfig {
  readonly region: string;
  readonly userPoolId: string;
  readonly userPoolClientId: string;
  readonly appsyncUrl: string;
}

function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required environment variable "${name}". ` +
        `Define it (see .env.example) before building or serving the SPA.`,
    );
  }
  return value;
}

export const appConfig: AppConfig = {
  region: required('VITE_AWS_REGION'),
  userPoolId: required('VITE_USER_POOL_ID'),
  userPoolClientId: required('VITE_USER_POOL_CLIENT_ID'),
  appsyncUrl: required('VITE_APPSYNC_URL'),
};

// AppSync exposes GraphQL subscriptions over a real-time WebSocket endpoint
// derived from the HTTP GraphQL URL. Both AWS AppSync URL shapes are handled:
//   https://xxxx.appsync-api.<region>.amazonaws.com/graphql  ->
//   wss://xxxx.appsync-realtime-api.<region>.amazonaws.com/graphql
export function realtimeUrlFromAppsyncUrl(appsyncUrl: string): string {
  return appsyncUrl
    .replace('https://', 'wss://')
    .replace('http://', 'ws://')
    .replace('appsync-api', 'appsync-realtime-api');
}
